import{WEB_SAFE_FONTS as e}from"@wix/shoutout-email-model-v3";const t=Object.values(e).map(e=>e.displayName.toLowerCase()),n=e=>t.includes(e.toLowerCase());export{n as isSystemFont};
//# sourceMappingURL=isSystemFont.js.map